import React from "react";

import { BetOffer } from "@models";
import Time from "./Time";
import EventName from "./EventName";
import EventScoreAtBetTime from "./EventScoreAtBetTime";
import TitleScore from "./TitleScore";

export default function Title(props: {
	groupHasTitle: boolean;
	titleHasScore: boolean;
	offer: BetOffer;
}) {
	if (!props.groupHasTitle) {
		return null;
	}

	return (
		<div className="bet__event">
			<div className="bet__event__details">
				<div className="u-display--f">
					<Time offer={props.offer} />
				</div>
				<EventName offer={props.offer} isDetails={true} />
				{props.titleHasScore && (
					<EventScoreAtBetTime offer={props.offer} />
				)}
			</div>
			{props.titleHasScore && <TitleScore offer={props.offer} />}
		</div>
	);
}
